export { WysiwygProps } from './wysiwyg.props';
export const name = "WysiwygComponent";
